/** SiteAdmin/SubtypedProperties */
define([
	"dojo/_base/declare",
	"csi/property/Widget",
	"SiteAdmin/SubtypedViewMixin"
], function(declare,PropertyWidget,SubtypedViewMixin) {

	return declare([PropertyWidget, SubtypedViewMixin], {
	});
});